module.exports = __webpack_public_path__ + "open-id-connect-logo-2b1f16fb193520e16a2936913d886cf7.png";